var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarca3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.24 65.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#00213b;}.cls-4{fill:rgba(0,33,59,.8);fill-rule:evenodd;}.cls-5{opacity:.8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.01,
    y: 0.04,
    width: 187.19,
    height: 65.74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,23.13H14.74v4h-5.19v17.68H5.21V27.13H0v-4H0Zm16.71,0h12.42v3.99h-8.1v4.72h7.19v4h-7.19v4.96h8.4v4.02h-12.72V23.13h0Zm15.91,21.68V23.13h4.34v17.66h7.78v4.02h-12.12Zm33.32-18.06l-3.08,2.89h0c-.72-.78-1.37-1.38-1.95-1.79h0c-1.09-.77-2.32-1.16-3.7-1.16h0c-2.12,0-3.86,.77-5.24,2.32h0c-1.24,1.4-1.86,3.05-1.86,4.97h0c0,2.21,.79,4.03,2.38,5.45h0c1.34,1.22,2.92,1.83,4.73,1.83h0c1.08,0,2.04-.22,2.88-.67h0c.84-.44,1.8-1.22,2.87-2.33h0l3.07,2.89h0c-1.03,1.07-1.99,1.89-2.87,2.46h0c-1.77,1.14-3.74,1.71-5.91,1.71h0c-2.15,0-4.13-.53-5.96-1.6h0c-1.69-1-3.04-2.35-4.03-4.07h0c-1.03-1.77-1.54-3.66-1.54-5.67h0c0-2.01,.51-3.9,1.54-5.65h0c1.03-1.79,2.43-3.19,4.21-4.19h0c1.77-1.01,3.69-1.51,5.77-1.51h0c1.67,0,3.19,.33,4.57,.98h0c1.37,.65,2.75,1.7,4.14,3.15h0Zm13.15-4.13h0c3.35,0,6.17,1.25,8.48,3.76h0c1.99,2.16,2.99,4.69,2.99,7.59h0c0,2.02-.52,3.91-1.56,5.67h0c-1.01,1.69-2.37,3.05-4.08,4.07h0c-1.81,1.07-3.74,1.6-5.78,1.6h0c-2.91,0-5.46-.97-7.65-2.91h0c-2.55-2.27-3.83-5.12-3.83-8.58h0c0-1.98,.52-3.82,1.56-5.53h0c1.09-1.8,2.5-3.19,4.24-4.18h0c1.77-1.01,3.65-1.51,5.64-1.51Zm-.03,4.07h0c-2.03,0-3.75,.78-5.15,2.35h0c-1.25,1.39-1.87,3.07-1.87,5.05h0c0,1.02,.22,2,.65,2.95h0c.43,.95,1.04,1.77,1.83,2.45h0c1.36,1.18,2.89,1.76,4.59,1.76h0c1.2,0,2.34-.32,3.45-.95h0c1.14-.66,2.03-1.54,2.65-2.64h0c.65-1.12,.97-2.35,.97-3.68h0c0-2.19-.8-4.02-2.4-5.48h0c-1.32-1.21-2.9-1.81-4.72-1.81Zm18.96,18.12h-4.34V23.13h3.67l10.66,14.12v-14.12h4.34v21.68h-3.67l-10.66-14.12v14.12h0Zm18.69-21.68h12.42v3.99h-8.1v4.72h7.19v4h-7.19v4.96h8.4v4.02h-12.72V23.13h0Zm13.53,0h14.74v4h-5.19v17.68h-4.34V27.13h-5.21v-4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.64,65.78c1.06,0,5.52-21.05,5.52-22.06s-15.14-6.59-15.7-5.94c-.55,.65,9.12,28,10.18,28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.13,36.51c-.55,.73,4.5,29.27,5.51,29.27s8.91-20.01,8.91-21.21-13.88-8.79-14.42-8.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.49,36.45c-1.26-.4,1.52-27.03,1.91-28.22,.39-1.19,20.42-2.02,20.83-1.04,.41,.98-21.49,29.67-22.74,29.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.16,36.87c-1.32,.04-7.59-25.99-7.62-27.24-.04-1.25,18.58-8.72,19.29-7.93,.71,.79-10.35,35.14-11.67,35.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.51,.05c.75,.85-2.51,36.76-3.77,36.87-1.26,.11-13.12-23.87-13.25-25.37-.13-1.49,16.26-12.35,17.02-11.5Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarca3);
export default __webpack_public_path__ + "static/media/marca3.9516a849ce0bff070c3cfe1627520e9d.svg";
export { ForwardRef as ReactComponent };